import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { 
  listMerchantEntryApplications, 
  auditMerchantEntryApplication 
} from '../../api/merchantEntryApplication';
import { message } from 'antd';

// 分页查询商家入驻申请列表的异步 thunk
export const fetchMerchantEntryApplications = createAsyncThunk(
  'merchantEntryApplication/fetchList',
  async (params = {}, { rejectWithValue }) => {
    try {
      const response = await listMerchantEntryApplications(params);
      return response.data;
    } catch (error) {
      message.error('获取商家入驻申请列表失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

// 审核商家入驻申请的异步 thunk
export const auditApplication = createAsyncThunk(
  'merchantEntryApplication/audit',
  async ({ applicationId, status, rejectReason }, { dispatch, rejectWithValue }) => {
    try {
      const response = await auditMerchantEntryApplication(applicationId, status, rejectReason);
      
      if (response.code === 200) {
        message.success('审核成功');
        // 重新获取列表
        dispatch(fetchMerchantEntryApplications());
        return response.data;
      } else {
        message.error(response.message || '审核失败');
        return rejectWithValue(response);
      }
    } catch (error) {
      message.error('审核请求失败');
      return rejectWithValue(error.response?.data);
    }
  }
);

const merchantEntryApplicationSlice = createSlice({
  name: 'merchantEntryApplication',
  initialState: {
    applications: [],
    total: 0,
    page: 1,
    pageSize: 10,
    loading: false,
    error: null,
    currentApplication: null
  },
  reducers: {
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setPageSize: (state, action) => {
      state.pageSize = action.payload;
    },
    setCurrentApplication: (state, action) => {
      state.currentApplication = action.payload;
    }
  },
  extraReducers: (builder) => {
    builder
      // 获取列表
      .addCase(fetchMerchantEntryApplications.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchMerchantEntryApplications.fulfilled, (state, action) => {
        state.loading = false;
        state.applications = action.payload.records;
        state.total = action.payload.total;
        state.page = action.payload.current;
        state.pageSize = action.payload.size;
      })
      .addCase(fetchMerchantEntryApplications.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      // 审核申请
      .addCase(auditApplication.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(auditApplication.fulfilled, (state) => {
        state.loading = false;
      })
      .addCase(auditApplication.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  }
});

export const { 
  setPage, 
  setPageSize, 
  setCurrentApplication 
} = merchantEntryApplicationSlice.actions;

export default merchantEntryApplicationSlice.reducer;
